/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import React from 'react'
import { Alert, Button, Checkbox, Input } from 'antd'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import R from 'ramda'

const Top = styled.div`
  display: flex;
  align-items: center;
  padding-top: 16px;
  padding-bottom: 16px;
`
const Content = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: flex-start;
  max-height: 45vh;
  height: 45vh;
  overflow: auto;
  border: 1px solid #eee;
  border-radius: 5px;
  padding-top:10px
  padding-bottom:10px
`

const Filler = styled.div`
  flex: 1 1 0px;
`

const Controls = styled.div`
  padding-top: 16px;
  padding-bottom: 16px;
`

// const Buttons = styled.div`
//   display: flex;
//   justify-content: flex-end;
// `

const toggleData = (collection, data, single, itemToKey) => {
  if (single) {
    return collection.includes(data) ? [] : [data]
  }
  // return collection.includes(data)
  return R.indexOf(data, collection) >= 0
    ? collection.filter(u => itemToKey(u) !== itemToKey(data))
    : [...collection, data]
}

const renderDefaultTopControls = ({
  fuzzyTextFilter,
  setFuzzyTextValue,
  fuzzyFilterPredicate,
  checkAll,
  clearAll,
  inputRef,
}) => (
  <Top>
    {fuzzyFilterPredicate !== allTruePredicate && (
      <Input.Search
        placeholder="filter for items"
        ref={inputRef}
        value={fuzzyTextFilter}
        onChange={e => setFuzzyTextValue(e.target.value)}
        style={{
          marginLeft: '10px',
          flex: '0 0 250px',
          marginRight: '16px',
        }}
      />
    )}
    <Filler />
    <Button
      type="primary"
      onClick={checkAll}
      style={{ marginRight: '5px' }}
      size="small"
    >
      Select All
    </Button>
    <Button type="primary" onClick={clearAll} size="small">
      Clear All
    </Button>
  </Top>
)

const renderDefaultBottomControls = ({
  // noneSelectedError,
  confirm,
  confirmText,
  close,
  checked,
  showwarning = true,
}) => (
  <Controls
    css={{
      display: 'grid',
      gridTemplateColumns: 'auto max-content max-content',
      gridGap: '15px',
    }}
  >
    {/* <Buttons> */}
    {showwarning && checked.length <= 0 && (
      <Alert
        style={{ marginBottom: '0px', minHeight: '40px' }}
        message="Please select at least one Item"
        type="error"
      />
    )}
    {showwarning && checked.length > 0 && (
      <div style={{ padding: '8px 15px', minHeight: '40px' }} />
    )}
    {!showwarning && <div style={{ padding: '8px 15px', minHeight: '40px' }} />}
    {close && (
      <Button
        data-testid="item-select-modal-hide"
        onClick={close}
        style={{ height: '100%' }}
      >
        Cancel
      </Button>
    )}
    <Button
      style={{ marginRight: '20px', height: '100%', width: '100%' }}
      type="primary"
      data-testid="item-select-modal-save"
      onClick={confirm}
    >
      {confirmText}
    </Button>
    {/* </Buttons> */}
  </Controls>
)

const renderDefaultContent = ({
  dataList,
  getCheckProps,
  itemToLabel = _ => _,
  itemToKey,
  multiUtility,
  ...props
}) => (
  <Content style={{ ...props.contendDivStyle }}>
    {dataList.map(data => {
      const checkProps = getCheckProps(data)
      return (
        <div
          key={itemToKey(data)}
          style={{
            // height: '30px',
            overflow: 'wrap',
            flex: `0 0 ${checkProps.itemWidth || '80px'}`,
            width: 'max-content',
          }}
        >
          <Checkbox
            css={{
              display: 'block',
              // wordBreak: 'keep-all',
              // width: 'max-content',
            }}
            {...checkProps}
            disabled={(!multiUtility && !checkProps.checked) || false}
          >
            {itemToLabel(data)}
          </Checkbox>
        </div>
      )
    })}
  </Content>
)
const allTruePredicate = () => true
class ItemSelection extends React.Component {
  state = {
    noneSelectedError: false,
    checked: [],
    fuzzyTextFilter: null,
  }

  static propTypes = {
    data: PropTypes.array.isRequired,
    checked: PropTypes.array,
    setCheckedItems: PropTypes.func,
    itemToLabel: PropTypes.func,
    itemToKey: PropTypes.func,
    onConfirm: PropTypes.func,
    confirmText: PropTypes.string,
    renderTopControls: PropTypes.func,
    renderBottomControls: PropTypes.func,
    renderContent: PropTypes.func,
    title: PropTypes.string,
    close: PropTypes.func,
    itemWidth: PropTypes.string,
    fuzzyFilterPredicate: PropTypes.func,
    multiUtility: PropTypes.bool,
    disabled: PropTypes.bool,
  }

  static defaultProps = {
    data: [],
    itemToLabel: _ => _,
    itemToKey: _ => _,
    itemWidth: '80px',
    title: 'Select Items',
    confirmText: 'OK',
    renderTopControls: renderDefaultTopControls,
    renderBottomControls: renderDefaultBottomControls,
    renderContent: renderDefaultContent,
    fuzzyFilterPredicate: allTruePredicate,
    multiUtility: true,
    disabled: false,
    showwarning: true,
  }

  componentDidMount() {
    if (this.inputRef != null && this.inputRef.focus != null) {
      this.inputRef.focus()
    }
  }

  dataList = () => {
    return this.props.data
  }

  isControlled = () => this.props.setCheckedItems

  checkedList = () =>
    this.isControlled() ? this.props.checked : this.state.checked

  checkPropsOf = data => {
    const { itemToLabel = _ => _, itemToKey = _ => _ } = this.props
    return {
      label: itemToLabel(data),
      style: { margin: '0', padding: '.5em' },
      data,
      value: data,
      // onClick: this.toggleValue,
      onChange: this.toggleValue,
      // checked: this.checkedList().includes(data),
      checked: R.indexOf(data, this.checkedList()) >= 0,
      key: itemToKey(data),
      itemWidth: this.props.itemWidth,
    }
  }

  setFuzzyTextValue = fuzzyTextFilter => this.setState({ fuzzyTextFilter })

  toggleValue = (e, props) => {
    const data =
      props != null && props.data != null ? props.data : e.target.value
    const { itemToKey = _ => _ } = this.props

    if (!this.isControlled()) {
      this.setState(({ checked }) => {
        return {
          checked: toggleData(checked, data, this.props.single, itemToKey),
          noneSelectedError: false,
        }
      })
    } else {
      this.setState({ noneSelectedError: false })
      this.props.setCheckedItems(
        toggleData(this.checkedList(), data, this.props.single, itemToKey)
      )
    }
  }

  setCheckedItems = checked => {
    if (this.isControlled()) {
      this.setState({ noneSelectedError: checked.length === 0 })
      this.props.setCheckedItems(checked)
    } else {
      this.setState({
        checked,
        noneSelectedError: checked.length === 0,
      })
    }
  }

  checkAll = () => {
    const { fuzzyFilterPredicate } = this.props
    const { fuzzyTextFilter } = this.state
    this.setCheckedItems(
      R.uniq([
        ...this.checkedList().filter(item =>
          fuzzyFilterPredicate(item, fuzzyTextFilter)
        ),
        ...this.dataList().filter(item =>
          fuzzyFilterPredicate(item, fuzzyTextFilter)
        ),
      ])
    )
  }

  clearAll = () => this.setCheckedItems([])

  confirm = () => {
    const { onConfirm, showwarning = true } = this.props
    const confirmedUnits = this.checkedList()
    if (confirmedUnits.length === 0 && showwarning) {
      this.setState({ noneSelectedError: true })
    } else {
      onConfirm(confirmedUnits)
    }
  }

  render() {
    const { noneSelectedError } = this.state
    const {
      renderTopControls,
      renderBottomControls,
      renderContent,
      itemToLabel,
      itemToKey,
      fuzzyFilterPredicate,
      multiUtility,
      showwarning,
    } = this.props
    const renderProps = {
      dataList: this.dataList().filter(item =>
        fuzzyFilterPredicate(item, this.state.fuzzyTextFilter)
      ),
      checked: this.checkedList(),
      setCheckedItems: this.setCheckedItems,
      checkAll: this.checkAll,
      clearAll: this.clearAll,
      title: this.props.title,
      getCheckProps: this.checkPropsOf,
      noneSelectedError,
      confirmText: this.props.confirmText,
      confirm: this.confirm,
      close: this.props.close,
      itemToKey,
      itemToLabel,
      fuzzyTextFilter: this.state.fuzzyTextFilter,
      setFuzzyTextValue: this.setFuzzyTextValue,
      inputRef: n => (this.inputRef = n),
      multiUtility,
      disabled: this.props.disabled,
      contendDivStyle: this.props.contendDivStyle,
      showwarning,
    }
    return (
      <React.Fragment>
        {renderTopControls(renderProps)}
        {renderContent(renderProps)}
        {renderBottomControls(renderProps)}
      </React.Fragment>
    )
  }
}

export default ItemSelection
